import { createHttpService } from "../ApiService";
import type { TPaginationQuery, TPaginationQueryPartial } from "../common.interfaces";
import {
  archiveInstituteRequest,
  createAddressRequest,
  createInstituteLegacyRequest,
  createInstituteWireRequest,
  deleteAddressRequest,
  getAddressesRequest,
  getInstituteByIdRequest,
  getInstitutesRequest,
  listInstitutesWireRequest,
  onboardInstituteRequest,
  unarchiveInstituteRequest,
  updateAddressRequest,
  updateInstituteRequest,
} from "./instituteRequests";
import type { TCreateInstituteWireRequest } from "./institute.wire.interfaces";
import type {
  TCreateAddressRequest,
  TCreateInstituteRequest,
  TOnboardInstituteRequest,
  TUpdateAddressRequest,
  TUpdateInstituteRequest,
} from "./institute.interfaces";

export const useInstituteService = () => {
  const httpAPI = createHttpService();

  return {
    getInstitutes: (params?: TPaginationQueryPartial) =>
      getInstitutesRequest(httpAPI, params),

    listInstitutesWire: (params: TPaginationQuery) =>
      listInstitutesWireRequest(httpAPI, params),

    createInstituteLegacy: (
      legacy: TCreateInstituteRequest,
      actingUserId: string,
    ) => createInstituteLegacyRequest(httpAPI, legacy, actingUserId),

    createInstituteWire: (body: TCreateInstituteWireRequest) =>
      createInstituteWireRequest(httpAPI, body),

    getInstituteById: (id: string) => getInstituteByIdRequest(httpAPI, id),

    updateInstitute: (id: string, request: TUpdateInstituteRequest) =>
      updateInstituteRequest(httpAPI, id, request),

    getAddresses: (instituteId: string) =>
      getAddressesRequest(httpAPI, instituteId),

    createAddress: (request: TCreateAddressRequest) =>
      createAddressRequest(httpAPI, request),

    updateAddress: (
      instituteId: string,
      addressId: string,
      request: TUpdateAddressRequest,
    ) => updateAddressRequest(httpAPI, instituteId, addressId, request),

    deleteAddress: (instituteId: string, addressId: string) =>
      deleteAddressRequest(httpAPI, instituteId, addressId),

    archiveInstitute: (id: string) => archiveInstituteRequest(httpAPI, id),

    unarchiveInstitute: (id: string) => unarchiveInstituteRequest(httpAPI, id),

    onboardInstitute: (request: TOnboardInstituteRequest, actingUserId: string) =>
      onboardInstituteRequest(httpAPI, request, actingUserId),
  };
};
